import { useContext } from 'react';

import { STATUSES } from '@openclassrooms/ui-web/learning-activities';

import CourseContext from '../../contexts/courseContext';
import HeroAsset from './HeroAsset';
import CourseFinishedCard from '../CourseFinishedCard';
import CourseInProgressCard from '../CourseInProgressCard';

function HeroAside() {
  const { course, currentUser } = useContext(CourseContext);
  const {
    userCourseCompletionRate: progression,
    learningActivityStatus,
    userIsFollowingCourse,
  } = course;
  const isCourseFinished = progression === 100;

  if (
    currentUser &&
    progression !== null &&
    (learningActivityStatus === STATUSES.STATUS_IN_PROGRESS || userIsFollowingCourse)
  ) {
    if (isCourseFinished) {
      return <CourseFinishedCard />;
    }

    return <CourseInProgressCard />;
  }

  return <HeroAsset />;
}

export default HeroAside;
